import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const templeCrestConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Temple Crest Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Temple Crest, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_temple_crest',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Temple Crest',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Temple Crest Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring dependable tree care to 
     the residential neighborhoods of <strong>Temple Crest</strong>. This 
     established North Tampa community has mature trees throughout its streets 
     that add shade and character but also create real hazards as they age 
     and grow unchecked. Overhanging limbs near older homes, storm damage that 
     splits large canopies, and trees crowding utility lines are all situations 
     our experienced team handles every day.`,

    `We specialize in <strong>dangerous tree removal and targeted trimming in 
     established residential neighborhoods</strong> large limb reductions 
     near homes and carports, storm compromised trunks, trees with surface 
     root damage near aging driveways and sidewalks, and full removals 
     executed cleanly on tight lots. We protect your property throughout 
     every phase of the job.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable tree care 
     throughout <strong>Temple Crest</strong> and the surrounding 
     <strong>North Tampa</strong> communities keeping your home safe 
     and your trees well managed through every season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Temple Crest, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_TempleCrest = () => <LocationPage config={templeCrestConfig} />;
export default Services_TempleCrest;
